import { render, staticRenderFns } from "./GalleryShareDlg.vue?vue&type=template&id=151b7604&scoped=true"
import script from "./GalleryShareDlg.ts?vue&type=script&lang=ts&external"
export * from "./GalleryShareDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b7604",
  null
  
)

export default component.exports